// extracted by mini-css-extract-plugin
export default {"price":"eZ-z","onSale":"fZ-z","msrpLabelPrice":"gZ-z","originalPrice":"hZ-z","msrpLabel":"iZ-z","percentOff":"jZ-z"};